module.exports = __webpack_public_path__ + "static/media/Pop.fbe103c4.svg";